"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const mobx_1 = require("mobx");
class TrackViewStore {
    constructor() {
        this.modules = [];
        this.pages = new Map();
        this.content = new Map();
        this.initialContentSnapshot = {};
        this.totalPagesByModule = new Map();
    }
    get currentContentSnapshot() {
        const contentSnapshot = {};
        Array.from(this.content).forEach(([moduleId, moduleSelectedStatus]) => {
            contentSnapshot[moduleId] = {
                ...moduleSelectedStatus,
                manuallySelectedPages: moduleSelectedStatus.manuallySelectedPages.sort()
            };
        });
        return contentSnapshot;
    }
    get isDirty() {
        return !(0, isEqual_1.default)((0, mobx_1.toJS)(this.initialContentSnapshot), this.currentContentSnapshot);
    }
    get hasAddedContent() {
        return !(0, isEmpty_1.default)(this.currentContentSnapshot);
    }
    updateInitialContentSnapshot() {
        this.initialContentSnapshot = this.currentContentSnapshot;
    }
    setContent(contents) {
        this.content = new Map(contents.map(({ trackPageIds, moduleId }) => {
            const moduleTotalPages = this.totalPagesByModule.get(moduleId);
            const isSelected = moduleTotalPages === trackPageIds.length;
            const manuallySelectedPages = isSelected ? [] : trackPageIds;
            return [moduleId, { isSelected, manuallySelectedPages }];
        }));
        this.initialContentSnapshot = this.currentContentSnapshot;
    }
    setModules(modules) {
        this.modules = modules;
        this.modules.forEach((module) => {
            this.totalPagesByModule.set(module.id, module.totalPages);
        });
    }
    setPages(moduleId, pages) {
        this.pages.set(moduleId, pages);
    }
    addModule(moduleId) {
        this.content.set(moduleId, {
            isSelected: true,
            manuallySelectedPages: []
        });
    }
    removeModule(moduleId) {
        this.content.delete(moduleId);
    }
    addPage(moduleId, pageId) {
        const content = this.content.get(moduleId) || {
            isSelected: false,
            manuallySelectedPages: []
        };
        const manuallySelectedPages = [...content.manuallySelectedPages, pageId];
        const allPagesSelected = manuallySelectedPages.length === this.totalPagesByModule.get(moduleId);
        this.content.set(moduleId, {
            isSelected: allPagesSelected,
            manuallySelectedPages: allPagesSelected ? [] : manuallySelectedPages
        });
    }
    removePage(moduleId, pageId) {
        const content = this.content.get(moduleId) || {
            isSelected: false,
            manuallySelectedPages: []
        };
        if (content.isSelected) {
            const pages = this.pages.get(moduleId) || [];
            this.content.set(moduleId, {
                isSelected: false,
                manuallySelectedPages: pages
                    .filter((page) => page.id !== pageId)
                    .map((page) => page.id)
            });
        }
        else {
            this.content.set(moduleId, {
                isSelected: false,
                manuallySelectedPages: content.manuallySelectedPages.filter((p) => p !== pageId)
            });
        }
    }
    moduleIsChecked(moduleId) {
        const content = this.content.get(moduleId);
        return Boolean(content === null || content === void 0 ? void 0 : content.isSelected);
    }
    moduleIsPartiallyChecked(moduleId) {
        const content = this.content.get(moduleId);
        return Boolean(content && !content.isSelected && content.manuallySelectedPages.length > 0);
    }
    pageIsChecked(moduleId, pageId) {
        const content = this.content.get(moduleId);
        return Boolean(content &&
            (content.isSelected || content.manuallySelectedPages.includes(pageId)));
    }
}
__decorate([
    mobx_1.observable
], TrackViewStore.prototype, "modules", void 0);
__decorate([
    mobx_1.observable
], TrackViewStore.prototype, "pages", void 0);
__decorate([
    mobx_1.observable
], TrackViewStore.prototype, "content", void 0);
__decorate([
    mobx_1.observable
], TrackViewStore.prototype, "initialContentSnapshot", void 0);
__decorate([
    mobx_1.computed
], TrackViewStore.prototype, "currentContentSnapshot", null);
__decorate([
    mobx_1.computed
], TrackViewStore.prototype, "isDirty", null);
__decorate([
    mobx_1.computed
], TrackViewStore.prototype, "hasAddedContent", null);
__decorate([
    mobx_1.action
], TrackViewStore.prototype, "updateInitialContentSnapshot", null);
__decorate([
    mobx_1.action
], TrackViewStore.prototype, "setContent", null);
__decorate([
    mobx_1.action
], TrackViewStore.prototype, "setModules", null);
__decorate([
    mobx_1.action
], TrackViewStore.prototype, "setPages", null);
__decorate([
    mobx_1.action
], TrackViewStore.prototype, "addModule", null);
__decorate([
    mobx_1.action
], TrackViewStore.prototype, "removeModule", null);
__decorate([
    mobx_1.action
], TrackViewStore.prototype, "addPage", null);
__decorate([
    mobx_1.action
], TrackViewStore.prototype, "removePage", null);
exports.default = new TrackViewStore();
